<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon :color="status.color" v-bind="attrs" v-on="on">
        {{ status.icon }}
      </v-icon>
    </template>
    <span> {{ status.text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    ganhou: [String, Boolean, Number]
  },

  computed: {
    status() {
      if (this.ganhou === "S" || this.ganhou === true || this.ganhou == 1) {
        return {
          icon: "mdi-arrow-up-thick",
          text: "Ganhou",
          color: "success"
        };
      }
      return {
        icon: "mdi-arrow-down-thick",
        text: "Não atingiu a meta",
        color: "warning"
      };
    }
  }
};
</script>

<style></style>
